import React, { useState, useEffect, useMemo, createContext } from 'react';

import { localStorageKeys } from 'constants/localStorage';

import { initialState } from './initialState';

const GlobalComponentsContext = createContext(initialState);
GlobalComponentsContext.displayName = 'GlobalComponentsContext';

const GlobalComponentsContextProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  // TODO should this be in localStorage?
  useEffect(() => {
    localStorage.setItem(localStorageKeys.globalComponentsContext, JSON.stringify(state));
  }, [state]);

  const value = useMemo(() => ({ globalComponentsContext: state, setGlobalComponentsContext: setState }), [state]);

  return <GlobalComponentsContext.Provider value={value}>{children}</GlobalComponentsContext.Provider>;
};

export { GlobalComponentsContext, GlobalComponentsContextProvider };
